module.exports = __webpack_public_path__ + "static/media/myworknest-insignia.80fabdec.svg";